import { StyledFlex } from '@tryhackme/thm-ui-components';
import { StyledLoading } from 'src/common/components';
import { StyledContentSection } from '../../certificate-page.styles';
import { SkillsProps } from '../../certificate-page.types';
import { StyledTag } from './skills.styles';
export const Skills = ({
  isLoading,
  skills
}: SkillsProps) => <StyledContentSection data-sentry-element="StyledContentSection" data-sentry-component="Skills" data-sentry-source-file="skills.tsx">
    <h4>Skills gained</h4>
    <StyledFlex justifyContent="flex-start" gap="0.8rem" data-sentry-element="StyledFlex" data-sentry-source-file="skills.tsx">
      {isLoading ? <>
          <StyledLoading height="3rem" width="8rem" />
          <StyledLoading height="3rem" width="8rem" />
          <StyledLoading height="3rem" width="8rem" />
        </> : skills.map(skill => <StyledTag key={skill} size="default">
            {skill}
          </StyledTag>)}
    </StyledFlex>
  </StyledContentSection>;